import { Link } from "react-router-dom";
import * as api from "../api/client";
import { usePolledResource } from "../hooks/usePolling";
import { ServerCard } from "../components/ServerCard";

const POLL_INTERVAL_MS = 20_000;

export function Dashboard() {
  const { data, loading, error } = usePolledResource(api.listServers, POLL_INTERVAL_MS);
  const servers = data?.servers ?? [];

  const counts = {
    normal: servers.filter((s) => s.health_state === "normal").length,
    degraded: servers.filter((s) => s.health_state === "degraded").length,
    offline: servers.filter((s) => s.health_state === "offline").length,
  };

  return (
    <>
      <div className="topbar">
        <div className="page-title-group">
          <h1>Dashboard</h1>
          <p>An overview of every registered server and its current health.</p>
        </div>
        <Link to="/generator" className="btn btn-primary">
          Generate a server
        </Link>
      </div>

      <div className="field-grid" style={{ marginBottom: "var(--space-5)" }}>
        <div className="panel">
          <span className="field-label">Total servers</span>
          <div style={{ fontSize: "28px", fontWeight: 800 }}>{loading ? "—" : servers.length}</div>
        </div>
        <div className="panel">
          <span className="field-label">Online</span>
          <div style={{ fontSize: "28px", fontWeight: 800, color: "var(--status-normal)" }}>{counts.normal}</div>
        </div>
        <div className="panel">
          <span className="field-label">Degraded</span>
          <div style={{ fontSize: "28px", fontWeight: 800, color: "var(--status-degraded)" }}>{counts.degraded}</div>
        </div>
        <div className="panel">
          <span className="field-label">Offline</span>
          <div style={{ fontSize: "28px", fontWeight: 800, color: "var(--status-offline)" }}>{counts.offline}</div>
        </div>
      </div>

      {error && <div className="form-error">{error}</div>}

      {loading ? (
        <p className="muted">Loading servers…</p>
      ) : servers.length === 0 ? (
        <div className="empty-state">
          <p style={{ marginBottom: "var(--space-3)" }}>No servers have been registered yet.</p>
          <Link to="/generator" className="btn btn-primary">
            Generate your first Roblox client
          </Link>
        </div>
      ) : (
        <div className="server-grid">
          {servers.map((server) => (
            <ServerCard key={server.id} server={server} />
          ))}
        </div>
      )}
    </>
  );
}
